import {styled} from "@mui/material/styles"

export const Image = styled("img", {
    shouldForwardProp: prop => prop !== "threeFourImageryEnabled",
})<{threeFourImageryEnabled: boolean}>`
    ${({threeFourImageryEnabled}) =>
        threeFourImageryEnabled ? "width: 3.563rem;" : `height: 4.667rem; width: 3.5rem;`};
`
